import * as Sentry from '@sentry/vue';
import apiClient from '@/store/helpers/api-client';

const SET_LOG_IN_LOADING = 'SET_LOG_IN_LOADING';
const REQUEST_LOG_IN_CHECK_SUCCESS = 'REQUEST_LOG_IN_CHECK_SUCCESS';

const state = {
  isLoggedIn: false,
  tier: 'BASIC',
  id: null,
  name: null,
  userName: null,
  email: null,
  enableAutomaticScheduling: false,
  loading: false,
  error: false,
  errorMessage: '',
  success: false,
  onboardingStep: null,
  showOnboarding: false,
  isTrialActive: false,
  useTieredPricing: true,
};

const mutations = {
  // eslint-disable-next-line no-shadow
  [REQUEST_LOG_IN_CHECK_SUCCESS](state, data) {
    // eslint-disable-line
    state.isLoggedIn = true;
    state.id = data.id;
    state.tier = data.tier || 'BASIC';
    state.email = data.email;
    state.userName = data.userName;
    state.enableAutomaticScheduling = data.enableAutomaticScheduling || false;
    state.onboardingStep = data.onboardingStep;
    state.showOnboarding = data.showOnboarding || false;
    state.name = data.name;
    state.isTrialActive = data.isTrialActive;
    state.useTieredPricing = data.useTieredPricing;
  },
  // eslint-disable-next-line no-shadow
  [SET_LOG_IN_LOADING](state, isLoading) {
    // eslint-disable-line
    state.loading = isLoading;
  },
};

const actions = {
  async authenticate({ commit }) {
    if (state.isLoggedIn) return;
    commit(SET_LOG_IN_LOADING, true);
    try {
      const { data } = await apiClient.get('/me');
      Sentry.setUser(data);
      commit(REQUEST_LOG_IN_CHECK_SUCCESS, data);
    } finally {
      commit(SET_LOG_IN_LOADING, false);
    }
  },
};

export default {
  state,
  mutations,
  actions,
};
